// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__2iGvp","body":"style_body__jKrZU","nav":"style_nav__meQWy","header":"style_header___iMdc"};